export const normalize = (s) => {
  if (!s || typeof s !== "string") return "";
  return String(s)
    .trim()
    .toLowerCase()
    .replace(/:/g, " ") // Replace colons with space
    .replace(/-/g, " ") // Replace hyphens with space
    .replace(/[^\w\s']/g, "") // Remove other special characters (keep letters, numbers, spaces, apostrophes)
    .replace(/\s+/g, " ") // Normalize multiple spaces to single space
    .trim();
};

export const normalizeIpa = (s) => {
  if (!s || typeof s !== "string") return "";
  return s
    .trim()
    .replace(/^\/+|\/+$/g, "")
    .replace(/[ˈˌ]/g, "")
    .replace(/:/g, "ː")
    .replace(/\s/g, "")
    .toLowerCase();
};

export const isIpaCorrect = (user, correctList) => {
  if (!user || typeof user !== "string") return false;
  return correctList.some((c) => normalizeIpa(user) === normalizeIpa(c));
};

export const isTextCorrect = (user, correct, extra = []) => {
  if (!user || typeof user !== "string") return false;
  let norm = normalize(user);
  console.log("Normalized user answer: " + norm);
  console.log("Normalized correct answer answer: " + normalize(correct));
  if (norm === normalize(correct)) return true;
  return extra.some((e) => norm === normalize(e));
};
